define(["require", "exports", "jquery", "knockout", "log", "../utils/tools", "../models/UserContext", "../utils/kendoUtils", "../utils/strings"], function (require, exports, $, ko, log, tools, UserContext, KendoUtils, strings) {
    "use strict";
    var DataLogs = /** @class */ (function () {
        function DataLogs(entityName, entityId, multi) {
            this.filterByAny = ko.observable("");
            this.filterByEntityName = ko.observable("");
            this.filterByAction = ko.observable("all");
            this.filterByUser = ko.observable("");
            this.entityName = ko.observable("");
            this.entityId = ko.observable(0);
            this.searchFilter = ko.observable("");
            this.multiEntityLog = ko.observable(false);
            this.showChanges = ko.observable(false);
            this.clearFilterInProgress = false;
            var self = this;
            self.entityName(entityName);
            self.filterByEntityName(entityName);
            self.entityId(entityId);
            self.multiEntityLog(multi);
            self.showChanges.subscribe(function (value) {
                var grid = self.logsTable.getGridData();
                if (value) {
                    grid.showColumn("Changes");
                    self.logsTable.resizeColumn("Info", "50px");
                }
                else {
                    grid.hideColumn("Changes");
                    self.logsTable.resizeColumn("Info", "");
                }
            });
            log.log(strings.S("TestClauseTestClause").humanize().s);
        }
        DataLogs.prototype.open = function (title) {
            var self = this;
            if (!UserContext.hasAccess("Admin,PhoneNumbers.Logs,Customers.Logs")) {
                return;
            }
            tools.editModal({
                title: title || "Logs",
                buttonTitle: "Close",
                modalClass: "modal-lg",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(modal).modal("hide");
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'logs-view-template', data: entityName }\"></div>");
                    ko.applyBindings(self, modal);
                    self.initLogs();
                }
            });
        };
        DataLogs.prototype.openPhoneNumberHistory = function (phoneNumber, title) {
            var _this = this;
            tools.editModal({
                title: title || "Logs",
                buttonTitle: "Close",
                modalClass: "modal-lg",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(modal).modal("hide");
                },
                opened: function (modal) {
                    tools.ajaxGet({
                        url: "/E911/PhoneNumberHistoryJson?phoneNumber=".concat(phoneNumber),
                        success: function (data) {
                            $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'phone-numbers-history-view-template', data: entityName }\"></div>");
                            ko.applyBindings(_this, modal);
                            if (data.Success) {
                                _this.initPhoneNumberHistoryLogs(data.Data);
                            }
                        }
                    });
                }
            });
        };
        DataLogs.prototype.initPhoneNumberHistoryLogs = function (data) {
            $("#divNumbersHistoryTable").dataTable({
                data: data,
                columns: [
                    { data: "ActivatedTime", visible: true },
                    { data: "UpdatedTime", visible: true },
                    { data: "CallerName", visible: true },
                    { data: "Address1", visible: true },
                    { data: "Address2", visible: true },
                    { data: "City", visible: true },
                    { data: "State", visible: true },
                    { data: "ZipCode", visible: true },
                    { data: "latitude", visible: true },
                    { data: "longitude", visible: true }
                ],
                order: [[0, "desc"]]
            });
        };
        DataLogs.prototype.initLogs = function () {
            if (!UserContext.hasAccess("Admin,PhoneNumbers.Logs,Customers.Logs")) {
                return;
            }
            this.initKendoLogs("divAuditTable", 500);
        };
        DataLogs.prototype.initKendoLogs = function (gridId, height, autoHeight) {
            var self = this;
            var element = document.getElementById(gridId);
            ko.cleanNode(element);
            var autoHeightObj = {};
            if (autoHeight) {
                autoHeightObj = {
                    totalOffset: 46 + 41 + 3
                };
            }
            var columns = [
                { field: "Date", title: "Date", width: "160px", exportable: true },
                { field: "User", title: "User", width: "275px", exportable: true, template: '#=User# #= HostName != null ? " (" + HostName + ")" : ""#' },
                {
                    field: "ClientIpAddress", title: "IP", exportable: true, width: "140px",
                    attributes: {
                        "class": "text-center"
                    }
                },
                {
                    field: "Model", title: "Model", width: "140px",
                    hidden: !self.multiEntityLog() && self.entityName() !== "PhoneNumber",
                    exportable: true,
                    template: "#: window['global'].strings.S(Model).humanize() #",
                    attributes: {
                        "class": "text-center"
                    }
                },
                { field: "EntityInfo", title: "Title", width: "140px", exportable: true, hidden: !self.multiEntityLog() },
                {
                    field: "EventType", title: "Operation", width: "100px", exportable: true,
                    attributes: {
                        "class": "text-center"
                    }
                },
                { field: "Id", title: "Id", hidden: true, exportable: true },
                { field: "OriginalValue", title: "OriginalValue", hidden: true, exportable: true },
                { field: "NewValue", title: "NewValue", hidden: true, exportable: true },
                {
                    field: "Changes",
                    title: "Changes",
                    sortable: false,
                    exportable: true,
                    useTemplateValue: true,
                    template: function (dataItem) {
                        return DataLogs.formatChanges(dataItem);
                    },
                    hidden: true
                },
                {
                    field: "Info", title: "", sortable: false,
                    attributes: {
                        "class": "text-center"
                    },
                    template: function (dataItem) {
                        if (dataItem.NewValue && dataItem.NewValue !== "{}") {
                            return "<span class=\"cdr-status glyphicon glyphicon-exclamation-sign js-show-log-details\" aria-hidden=\"true\"></span>";
                        }
                        return "";
                    }
                },
                {
                    field: "", title: "", width: "165px", hidden: !self.multiEntityLog(), sortable: false,
                    template: function (dataItem) {
                        return DataLogs.logActions(dataItem);
                    }
                }
            ];
            self.logsTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Logs/GetKendoEntityLogs",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.entityName = self.entityName();
                                data.entityId = self.entityId();
                                if (self.multiEntityLog()) {
                                    if (self.filterByEntityName()) {
                                        data.entityName = self.filterByEntityName();
                                    }
                                }
                                else {
                                    data.entityName = self.entityName();
                                }
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                if (self.filterByUser()) {
                                    data.filterByUser = self.filterByUser();
                                }
                                if (self.filterByAction()) {
                                    data.filterByAction = self.filterByAction();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    }
                },
                gridOptions: {
                    height: height,
                    toolbar: kendo.template($("#logs-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    dataBound: function () {
                        self.clearFilterInProgress = false;
                    }
                },
                enableExport: {
                    entityName: "Log",
                    title: "Log Records",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: false
                },
                gridId: gridId,
                showPagerOnTop: false,
                autoHeight: autoHeightObj,
                controller: self
            };
            self.logsTable.initGrid(gridOptions);
            ko.applyBindings(self, element);
            $("#".concat(gridId)).kendoTooltip({
                autoHide: false,
                showOn: "click",
                position: "left",
                filter: ".js-show-log-details",
                //width: 200,
                show: function (e) {
                    this.popup.element.addClass("logs-tool-tip");
                },
                content: function (e) {
                    var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(e.target);
                    return DataLogs.formatChanges(dataItem);
                }
            }).data("kendoTooltip");
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                if (!self.clearFilterInProgress) {
                    self.logsTable.getGridData().dataSource.read();
                }
            });
            self.filterByEntityName.subscribe(function () {
                if (!self.clearFilterInProgress && self.multiEntityLog()) {
                    self.logsTable.getGridData().dataSource.read();
                }
            });
            self.filterByUser.subscribe(function () {
                if (!self.clearFilterInProgress) {
                    self.logsTable.getGridData().dataSource.read();
                }
            });
            self.filterByAction.subscribe(function () {
                if (!self.clearFilterInProgress) {
                    self.logsTable.getGridData().dataSource.read();
                }
            });
            if (self.multiEntityLog()) {
                $("#logsFilterModelHolder").show();
            }
            self.usersDropDownList = $("#logsFilterUser", element).kendoComboBox({
                autoBind: false,
                valuePrimitive: true,
                filter: "contains",
                placeholder: "Select user...",
                dataTextField: "Login",
                dataValueField: "Login",
                dataSource: {
                    transport: {
                        read: {
                            url: "/Logs/GetUsersLookup",
                            type: "POST",
                            dataType: "json"
                        }
                    },
                    schema: {
                        data: function (response) { return response.Data; },
                        total: "Total"
                    },
                    serverFiltering: true
                },
                dataBound: function () {
                },
                cascade: function (e) {
                    if (e.sender.dataItem()) {
                        self.filterByUser(e.sender.dataItem().Login);
                    }
                    else {
                        self.filterByUser(undefined);
                    }
                }
            }).data("kendoComboBox");
            self.modelDropDownList = $("#logsFilterModel", element).kendoDropDownList({
                cascade: function (e) {
                    if (e.sender.dataItem()) {
                        self.filterByEntityName(e.sender.dataItem().value);
                    }
                    else {
                        self.filterByEntityName(undefined);
                    }
                }
            }).data("kendoDropDownList");
            self.actionDropDownList = $("#logsFilterAction", element).kendoDropDownList({
                cascade: function (e) {
                    if (e.sender.dataItem()) {
                        self.filterByAction(e.sender.dataItem().value);
                    }
                    else {
                        self.filterByAction(undefined);
                    }
                }
            }).data("kendoDropDownList");
        };
        DataLogs.prototype.exportTo = function () {
            this.logsTable.exportTo();
        };
        DataLogs.prototype.clearFilter = function () {
            var self = this;
            self.clearFilterInProgress = true;
            self.filterByAny("");
            self.usersDropDownList.select(-1);
            self.modelDropDownList.select(0);
            self.actionDropDownList.select(0);
            setTimeout(function () {
                self.logsTable.getGridData().dataSource.read();
            }, 201);
        };
        DataLogs.prototype.refreshLogs = function () {
            if (this.logsTable) {
                this.logsTable.getGridData().dataSource.read();
            }
        };
        DataLogs.logActions = function (logItem) {
            var controller = "";
            var action = "Edit";
            switch (logItem.Model) {
                case "Customer":
                    controller = "Customers";
                    break;
                /*case "Server":
                    controller = "Servers";
                    break;
                case "PhoneNumberProvider":
                    controller = "PhoneNumberProviders";
                    break;*/
                case "PhoneNumber":
                    action = "Details";
                    controller = "PhoneNumbers";
                    break;
                /*case "OfficeLocation":
                    controller = "OfficeLocations";
                    break;
                case "ToDo":
                    controller = "ToDo";
                    break;*/
            }
            var template, html = "", data;
            if (controller && logItem.RecordId) {
                data = { url: "/".concat(controller, "/").concat(action, "/").concat(logItem.RecordId) };
            }
            if (logItem.EventType === "Deleted") {
                template = kendo.template('<a class= "btn btn-danger" href="#: url #"><i class="fa fa-history"></i> Restore and Edit</a>');
            }
            else {
                template = kendo.template('<a class="btn btn-info" href="#: url #" ><i class="fa fa-edit"></i> Edit</a>');
            }
            if (data) {
                html = template(data);
            }
            return html;
        };
        DataLogs.formatChanges = function (logItem) {
            var oldValues = JSON.parse(DataLogs.escapeSpecialCharacters(logItem.OriginalValue));
            var newValues = JSON.parse(DataLogs.escapeSpecialCharacters(logItem.NewValue));
            var newValue;
            var formatedResult = "";
            var property;
            if (logItem.EntityInfo) {
                formatedResult += "<div style=\"margin-bottom:8px;white-space: nowrap;\"><b>".concat(logItem.EntityInfo, "</b></div>");
            }
            if (logItem.EventType === "Added" || logItem.EventType === "Impersonate" || (logItem.EventType === "Login" && logItem.Model === "PbxLogin")) {
                for (property in newValues) {
                    if (newValues.hasOwnProperty(property)) {
                        // do stuff
                        newValue = newValues[property] || "none";
                        if (newValue instanceof Object) {
                            newValue = JSON.stringify(newValue);
                        }
                        if (newValues[property]) {
                            formatedResult += "<div style=\"margin-bottom:8px;white-space: nowrap;\">".concat(property, "<i> set to </i><b style=\"color:#87b87f\">").concat(newValue, "</b></div>");
                        }
                    }
                }
            }
            else if (logItem.EventType === "Deleted") {
                for (property in newValues) {
                    if (newValues.hasOwnProperty(property)) {
                        var setTo = logItem.Model === "MySQL_STS" ? "was set to" : "set to";
                        // do stuff
                        newValue = newValues[property] || "none";
                        if (newValue instanceof Object) {
                            newValue = JSON.stringify(newValue);
                        }
                        if (newValues[property]) {
                            formatedResult += "<div style=\"margin-bottom:8px;white-space: nowrap;\">".concat(property, "<i> ").concat(setTo, " </i><b style=\"color:#87b87f\">").concat(newValue, "</b></div>");
                        }
                    }
                }
            }
            else if (logItem.EventType === "Export") {
                for (property in newValues) {
                    if (newValues.hasOwnProperty(property)) {
                        // do stuff
                        newValue = newValues[property] || "none";
                        if (newValue instanceof Object) {
                            newValue = "<pre>".concat(JSON.stringify(newValue), "</pre>");
                        }
                        if (property === "fileName") {
                            newValue = "<a target=\"_blank\" href=\"/Upload/ExportFiles/".concat(newValue, "\">").concat(newValue, "</a>");
                        }
                        if (newValues[property]) {
                            formatedResult += "<div style=\"margin-bottom:8px;white-space: nowrap;\">".concat(property, "<i> set to </i><b style=\"color:#87b87f\">").concat(newValue, "</b></div>");
                        }
                    }
                }
            }
            else if (logItem.EventType === "ApiRequest") {
                for (property in newValues) {
                    if (newValues.hasOwnProperty(property)) {
                        // do stuff
                        newValue = newValues[property] || "none";
                        if (newValue instanceof Object) {
                            newValue = "<pre>".concat(JSON.stringify(newValue, null, 4), "</pre>");
                        }
                        if (property === "fileName") {
                            newValue = "<a target=\"_blank\" href=\"/Upload/ExportFiles/".concat(newValue, "\">").concat(newValue, "</a>");
                        }
                        if (newValues[property]) {
                            formatedResult += "<div style=\"margin-bottom:8px;white-space: nowrap;\">".concat(property, "<i> set to </i><b style=\"color:#87b87f\">").concat(newValue, "</b></div>");
                        }
                    }
                }
            }
            else if (logItem.EventType === "Modified") {
                for (property in newValues) {
                    if (newValues.hasOwnProperty(property)) {
                        var oldValue = oldValues[property];
                        newValue = newValues[property] || "none";
                        if (oldValue) {
                            formatedResult += "<div style=\"margin-bottom:8px;white-space: nowrap;\">".concat(property, "<i> changed from </i><b style=\"color:#307ecc\">").concat(oldValue, "</b><i>  to </i><b style=\"color:#87b87f\">").concat(newValue, "</b></div>");
                        }
                        else {
                            formatedResult += "<div style=\"margin-bottom:8px;white-space: nowrap;\">".concat(property, "<i> set to </i><b style=\"color:#87b87f\">").concat(newValue, "</b></div>");
                        }
                    }
                }
            }
            else if (logItem.EventType === "Deleted") {
                formatedResult += "<div style=\"margin-bottom:8px;white-space: nowrap;\"><i> Id </i><b style=\"color:#307ecc\">".concat(logItem.RecordId, "</b></div>");
            }
            return formatedResult;
        };
        DataLogs.escapeSpecialCharacters = function (str) {
            return str
                .replace(/\n/g, "\\n")
                .replace(/\r/g, "\\r")
                .replace(/\t/g, "\\t")
                .replace(/\\n/g, "\\n")
                .replace(/\\'/g, "\\'")
                .replace(/\\"/g, '\\"')
                .replace(/\\&/g, "\\&")
                .replace(/\\r/g, "\\r")
                .replace(/\\t/g, "\\t")
                .replace(/\\b/g, "\\b")
                .replace(/\\f/g, "\\f");
        };
        return DataLogs;
    }());
    return DataLogs;
});
//# sourceMappingURL=dataLogs.js.map


//////////////////
// WEBPACK FOOTER
// ./build/shared/dataLogs.js
// module id = 9
// module chunks = 2